import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Compatible sur tablette Apple iPad ou Android.", -1)
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dtg_link = _resolveComponent("dtg-link")!
  const _component_dtg_modal_content = _resolveComponent("dtg-modal-content")!

  return (_openBlock(), _createBlock(_component_dtg_modal_content, null, {
    title: _withCtx(() => [
      _createTextVNode(" Téléchargez l’application MyDTG ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('content'))
      }, [
        _hoisted_1,
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('stores'))
        }, [
          _createElementVNode("a", {
            class: _normalizeClass(_ctx.b('store-link-apple')),
            href: _ctx.appStoreUrl,
            target: "_blank"
          }, [
            _createElementVNode("img", {
              class: _normalizeClass(_ctx.b('store-link-badge')),
              src: _ctx.badgeAppStoreUrl,
              alt: "Télécharger dans l'App Store"
            }, null, 10, _hoisted_3)
          ], 10, _hoisted_2),
          _createElementVNode("a", {
            href: _ctx.playMarketUrl,
            target: "_blank"
          }, [
            _createElementVNode("img", {
              class: _normalizeClass(_ctx.b('store-link-badge')),
              alt: "Disponible sur Google Play",
              src: "https://play.google.com/intl/en_us/badges/static/images/badges/fr_badge_web_generic.png"
            }, null, 2)
          ], 8, _hoisted_4)
        ], 2),
        _createElementVNode("p", null, [
          _createElementVNode("b", null, [
            _createTextVNode(" Avez-vous déjà téléchargé l'app? Cliquez "),
            _createVNode(_component_dtg_link, { href: "/" }, {
              default: _withCtx(() => [
                _createTextVNode(" ICI ")
              ]),
              _: 1
            }),
            _createTextVNode(" pour l'ouvrir et gérer vos DTG. ")
          ])
        ])
      ], 2)
    ]),
    _: 1
  }))
}